// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"SnapSlider-module--itemContainer--oHlyK","item":"SnapSlider-module--item--3Tsc-"};